<!-- 页脚 -->
<template>
  <div class="mt-[100px] h-[224px] shrink-0 lt-md:h-auto" :style="{ background: backgroundSrc,backgroundSize:'100% 100%' }">
    <div class="container-1500 flex h-full items-center pt-[80px] lt-md:block">
      <img :src="$getImageSrc('logo-white.png')" class="w-[240px] mr-[114px] lt-md:hidden" />
      <div class="lt-md:mb-[20px] lt-md:pt-[80px]">
        <div class="contact text-[14px]" style="color: #fff;" v-html="info['联系方式']"></div>
        <el-divider class="!my-[14px] !bg-[#75c5f2]"></el-divider>
        <p class="text-[14px]" style="color: #fff;" v-html="info['底部版权']"></p>
      </div>
      <div class="ml-auto text-center">
        <div class="mb-[8px] inline-block w-[84px]" v-html="info['首页底部二维码']"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { websiteInfo } from '@/api/article';

export default {
  name: 'Footer',
  data() {
    return {
      backgroundSrc: `url(${this.$getImageSrc('footer-bg.png')}) center bottom no-repeat`,
      info: {
        联系方式: '',
        首页底部二维码: '',
        底部版权: '',
      },
    };
  },
  methods: {
    getData() {
      websiteInfo().then((res) => {
        const data = res.data.list;
        data.map((item) => {
          this.info[item.title] = item.content;
        });
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.contact ::v-deep p {
  display: inline-block;
}
</style>
